export default __webpack_public_path__ + "static/media/qrcode-site-1920w.126d545e.webp";